const StartIcon = () => (
  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5H20C24.4183 0.5 28 4.08172 28 8.5V20.5C28 24.9183 24.4183 28.5 20 28.5H8C3.58172 28.5 0 24.9183 0 20.5V8.5Z"
      fill="#12B76A"
    />
    <path
      d="M7.3335 14.5001V11.5334C7.3335 7.85007 9.94183 6.34174 13.1335 8.18341L15.7085 9.66674L18.2835 11.1501C21.4752 12.9917 21.4752 16.0084 18.2835 17.8501L15.7085 19.3334L13.1335 20.8167C9.94183 22.6584 7.3335 21.1501 7.3335 17.4667V14.5001Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StartIcon;
